<template>
  <div id="inicio" class="container">
    <!-- <div class="row justify-content-md-center">
      <div class="col-10 mt-3">
        <div class="alert alert-primary text-left" role="alert">
          <b>¡BIENVENIDO A IPER {{ $store.state.version }}!</b><br />
          Hemos realizado mejoras de rendimiento en la aplicación. <br />
          En el módulo <b>Lista Centro Trabajo</b> encontrarás:
          <ul>
            <li>
              Se ha agregado la columna de <b>"FECHA"</b> a la tabla de la vista <b>"Lista Centro de
                Trabajo"</b>.
            </li>
            <li>
              Se ha agregado la columna de <b>"DIRECCIÓN"</b> al archivo de Excel consultable y descargable
              en la vista
              <b>"Lista Centro de
                Trabajo"</b>.
            </li>
          </ul>
        </div>
      </div>
    </div> -->
    <div class="col-12 bienvenido">
      <h1 class="letra-m"><b>Bienvenido</b></h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "inicio",
  data() {
    return {};
  },
  methods: {
    fondo_naranja() {
      var body = document.getElementsByTagName("body")[0];
      body.style.backgroundImage = "url(img/fondos/fondo-naranja.jpg)";
      $("#wrapper").toggleClass("toggled");
    },
  },
  created() {
    if (!this.$store.state.email) {
      this.$router.push("/");
    }
    // INICIALIZA LOS FONDOS DE LA APP SEGÚN EL MÓDULO DONDE SE ENCUENTRE EL USUARIO
    // this.fondo_naranja();
  },
};
</script>
